import validator from "validator";
import { cloneDeep } from "lodash";

// Const
import { defaultMetadataSetState } from "../../const";

const getDefaultMetadataSetState = (selectedMetadataSet) => {
  const metadataSetState = cloneDeep(defaultMetadataSetState);
  if (!selectedMetadataSet)
    return metadataSetState;

  metadataSetState.name.value = selectedMetadataSet.rawData.name;
  metadataSetState.name.valid = true;

  metadataSetState.url.value = selectedMetadataSet.rawData.loginUrl || '';
  metadataSetState.issuer.value = selectedMetadataSet.rawData.issuerUri || '';

  metadataSetState.certificate.value = selectedMetadataSet.rawData.idpCertFileName;
  metadataSetState.certificate.dirty = true;
  metadataSetState.certificate.valid = true;

  metadataSetState.logoutUrl.value = selectedMetadataSet.rawData.logoutUrl || '';
  metadataSetState.fingerprint.value = selectedMetadataSet.rawData.idpCertFingerprint || '';

  return metadataSetState;
}

const changeName = (name, value) => {
  name.value = value;
  name.dirty = true;
  name.valid = validator.isByteLength(value, { min: 1, max: 64 });
}

const changeByManualOrImport = (byManualOrImport, value) => {
  byManualOrImport.value = value;
}

const changeUrl = (url, value) => {
  url.value = value;
  url.dirty = true;
  url.valid = (!url.required || (url.required && value)) ? true : false;
}

const changeIssuer = (issuer, value) => {
  issuer.value = value;
  issuer.dirty = true;
  issuer.valid = (!issuer.required || (issuer.required && value)) ? true : false;
}

const changeCertificate = (certificate, value, metadataSetState) => {
  certificate.value = value?.name || '';
  certificate.file = value || null;
  certificate.dirty = true;
  certificate.valid = (
    !metadataSetState.byManualOrImport.value ||
    (metadataSetState.byManualOrImport.value && certificate.required && value)
  ) ? true : false;
}

const changeLogoutUrl = (logoutUrl, value) => {
  logoutUrl.value = value;
  logoutUrl.dirty = true;
  logoutUrl.valid = (!logoutUrl.required || (logoutUrl.required && value)) ? true : false;
}

const changeFingerprint = (fingerprint, value) => {
  fingerprint.value = value;
  fingerprint.dirty = true;
  fingerprint.valid = (!fingerprint.required || (fingerprint.required && value)) ? true : false;
}

const changeMetadataSetXml = (metadataSetXml, value, metadataSetState) => {
  metadataSetXml.value = value?.name || '';
  metadataSetXml.file = value || '';
  metadataSetXml.dirty = true;
  metadataSetXml.valid = (
    !metadataSetState.byManualOrImport.value ||
    (metadataSetState.byManualOrImport.value && metadataSetXml.required && value)
  ) ? true : false;
}

export default {
  getDefaultMetadataSetState,
  changeName,
  changeByManualOrImport,
  changeUrl,
  changeIssuer,
  changeCertificate,
  changeLogoutUrl,
  changeFingerprint,
  changeMetadataSetXml
};